import { TextInputField } from './TextInputField';
import type { FormFieldComponent } from './types';
import { fieldRule, readFormField } from './useFormField';

const ROLE = 'genericInputField';
const FALLBACK_NAME = 'inputFormField';

const GenericFormInputField: FormFieldComponent = () => (
  <TextInputField role={ROLE} fallbackName={FALLBACK_NAME} type="text" multiline={false} />
);

GenericFormInputField.formSchema = content => fieldRule(readFormField(content, 'genericFields', ROLE), FALLBACK_NAME);

export default GenericFormInputField;
